<div class="profile-container">
    <div class="profile-info-container">
      <div class="cover-photo">
        <img [src]="coverPhotoUrl" alt="Cover Photo" class="cover-photo-img">
        <button mat-icon-button class="edit-cover-photo-button" (click)="fileInput.click()">
          <mat-icon>camera_alt</mat-icon>
        </button>
        <input type="file" #fileInput (change)="onChangeCoverPhoto($event)" hidden>
      </div>
      <div class="profile-photo">
        <img [src]="profilePhotoUrl" alt="Profile Photo" class="profile-picture">
        <button mat-icon-button class="edit-profile-picture-button" (click)="onChangeProfilePicture()">
          <mat-icon>camera_alt</mat-icon>
        </button>

        <!--<input type="file" #fileInput2 (change)="onChangeProfilePicture($event)" hidden>-->
        
      </div>
      <div class="profile-info">
        
        <div>
          
          <h2>{{ userData?.publicName }}</h2>
          <h5> {{ userData?.description}}, {{ userData?.ville}}</h5>
          <h5> {{ userData?.telephone}}</h5>
        </div>
        
        <div class="my-row" style="color: rgb(255, 255, 255); margin-left: 10px; margin-right: 10px; min-height: 15px; ">
          
          <!--<div class="actions">
            <button class="follow">Suivre</button>
            <button class="message">Message</button>
            <button class="more">...</button>
          </div>-->
          <div class="actions">
            <!-- Bouton Suivre avec une icône -->
            <button mat-icon-button>
              <mat-icon>person_add</mat-icon>
            </button>
          
            <!-- Bouton Message avec une icône -->
            <button mat-icon-button>
              <mat-icon>message</mat-icon>
            </button>
          
            <!-- Bouton More (menu) avec une icône -->
            <button mat-icon-button>
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
          

          <div class="container3">
             <div class="row">
              <div class="col-4" style="display: flex; text-align: center;">
                <span>Suiveurs: {{ followersCount }}</span>
              </div>
              <div class="col-4" style="display: flex; text-align: center;">
                <p>Suivi(e)s: {{ followingCount }}</p>
              </div>
              <div class="col-4" style="display: flex; text-align: center;">
                <p>J'aime: 10000</p>
              </div>
            </div>
            
          </div>
          <button mat-button (click)="onEditProfile()" class="edit-profile-btn"><mat-icon>edit</mat-icon>Modifier profil</button>
        </div>
        
      </div>
    </div>
    <div class="user-posts">
      <h3>Publications</h3>
      
      <div *ngFor="let post of userPosts" class="myposts">
        <app-post  [postData]="post"></app-post>
      </div>
    </div>
  </div>
  